import { Badge } from "@/components/ui/badge";
import { useT } from "@/contexts/I18nContext";

const SYSTEM_STYLE = {
    feedlot: { bg: "bg-[#1A3626]/10", text: "text-[#1A3626]", border: "border-[#1A3626]/25" },
    semi:    { bg: "bg-[#5C7A3F]/15", text: "text-[#3F5A28]", border: "border-[#5C7A3F]/30" },
    pasture: { bg: "bg-[#88A560]/20", text: "text-[#3F5A28]", border: "border-[#88A560]/40" },
};

const BENCH_STYLE = {
    excellent: { bg: "bg-[#1A3626]", text: "text-white", label: "bench_excellent" },
    good:      { bg: "bg-[#5C7A3F]", text: "text-white", label: "bench_good" },
    regular:   { bg: "bg-[#D99533]", text: "text-white", label: "bench_regular" },
    bad:       { bg: "bg-[#C55D42]", text: "text-white", label: "bench_bad" },
};

const SYSTEM_LABELS = {
    feedlot: "sys_feedlot",
    semi: "sys_semi",
    pasture: "sys_pasture",
};

export function SystemBadge({ system, className = "" }) {
    const { t } = useT();
    const s = SYSTEM_STYLE[system] || SYSTEM_STYLE.feedlot;
    const labelKey = SYSTEM_LABELS[system] || "sys_feedlot";
    return (
        <Badge className={`${s.bg} ${s.text} border ${s.border} hover:${s.bg} font-medium ${className}`}>
            {t(labelKey)}
        </Badge>
    );
}

export function BenchmarkBadge({ value, className = "" }) {
    const { t } = useT();
    if (!value || !BENCH_STYLE[value]) {
        return <span className={`text-xs text-muted-foreground ${className}`}>—</span>;
    }
    const s = BENCH_STYLE[value];
    return (
        <Badge className={`${s.bg} ${s.text} hover:${s.bg} font-medium ${className}`}>
            {t(s.label)}
        </Badge>
    );
}
